import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import SearchIcon from "@mui/icons-material/Search";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Fragment } from "react";
import Lottie from "react-lottie";
import { Collage, Collage2, FAQ2 } from "../components/Sections";

export default function WebDesign() {
  useEffect(() => {}, []);
  const dark = true;

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  color: "white",
                  zIndex: 999,
                }}
              >
                <div
                  style={{
                    fontSize: state.auth.isMobile
                      ? state.auth.isTablet
                        ? "5.2vw"
                        : "22px"
                      : "2.2vw",
                  }}
                >
                  Web Design Agency <br />
                  <span style={{ color: "yellow" }}>
                    That Craft InspiringDigital Experience
                  </span>
                </div>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Transforming your ideas into visually stunning, user-friendly
                websites.
              </div>
            </div>
          </div>
        </div>

        <ContentSideBySideInv
          title={<h2>Our Web Design Process</h2>}
          subtitle={
            <div>
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Discovery Phase and Research
              </div>
              We gather insights through client discussions and industry
              analysis. Our team identifies goals and user expectations. We also
              conduct market research to align design with audience needs.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                UX Design for Enhanced Interaction
              </div>
              We structure user flows that improve engagement and retention. Our
              team maps intuitive navigation paths. We also simplify
              interactions to create a frictionless browsing experience.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                UI Design for Visual Appeal
              </div>
              We create high-impact visuals that strengthen brand identity. Our
              team designs interactive elements that improve usability. We also
              work on typography and color schemes for better readability.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "purple",
                    marginRight: "15px",
                  }}
                />
                Support and Maintenance for Long-Term Performance
              </div>
              We monitor website performance and address technical issues. Our
              team updates security patches and optimizes loading speeds. We
              also implement SEO improvements to sustain organic reach.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/webdesign.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ThreeSideBySide
          hero={"What Web Designing Services Do we Offer"}
          background={""}
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Responsive Web Design"}
                text={`We create mobile-friendly websites that adjust seamlessly to any screen size. A structured layout improves usability and maintains visual consistency.`}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Maintenance and Updates"}
                text={`We update websites with blogs, events, and announcements. A dynamic content management system allows easy modifications and real-time edits.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"API Integration for Extended Functionality"}
                text={`We integrate third-party solutions to improve website capabilities. Google services, email automation, and SMS gateways improve connectivity.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Payment Gateway Integration"}
                text={`We enable secure and flexible payment processing. E-commerce platforms benefit from a seamless checkout experience.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"CMS Website Design"}
                text={`We develop content management systems that simplify website updates. A protected dashboard allows businesses to modify content and upload visuals.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"SEO-Optimized Web Design"}
                text={`We structure websites to improve organic search rankings. A technically optimized design increases discoverability and attracts targeted visitors.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <FAQ2
          invert={!dark}
          q1="What makes a website user-friendly?"
          a1="A user-friendly website is structured for intuitive navigation and fast-loading pages. It involves responsive design and accessible layouts. A simplified user flow further improves engagement. Clear CTAs also help make sites interactive as they direct users to key actions. Well-placed content sections further improve readability and keep visitors engaged."
          q2="How long does it take to design a website?"
          a2="Website design timelines depend on complexity and functionality requirements. A standard business website is completed within four to eight weeks. Advanced platforms take longer based on integrations and customizations. E-commerce websites with product catalogs and payment systems require additional development time. Websites with custom features go through extended testing phases before launch."
          q3="What is the difference between UX and UI design?"
          a3="UX design concentrates and works on structuring user interactions and optimizing navigation. UI design improves aesthetics and enriches visual appeal. Both elements work together to improve the overall digital experience. UX improves usability by simplifying workflows. UI strengthens brand identity by using consistent design elements."
          q4="Can I update my website after it is live?"
          a4="Websites with a content management system (CMS) allow easy modifications. Businesses can update text, images, and blog posts without technical expertise. Dynamic content sections enable quick updates without coding. User permissions allow teams to control different aspects of the site securely."
          q5="Why is responsive design important?"
          a5="A responsive website adapts to different screen sizes and improves accessibility. Mobile-friendly layouts improve engagement and search engine rankings. Google prioritizes mobile-responsive sites in rankings. A seamless experience across devices increases user retention and reduces bounce rates."
          q6="How does SEO impact web design?"
          a6="SEO-friendly websites improve visibility on search engines and attract targeted traffic. A structured layout and optimized content increase search rankings and enhance discoverability. Faster page speeds improve search rankings and user experience. Schema markup helps search engines understand website content better."
        />
        <Stats />

        <SpacerV height={"100px"} background="#111" />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
